import {
  Row,
  Col,
  Card,
  Button,
  Typography,
  Empty,
  Skeleton,
  notification,
  message,
  Badge,
  Space,
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  EnvironmentOutlined,
  NotificationOutlined,
  StarOutlined,
} from "@ant-design/icons";
import Meta from "antd/es/card/Meta";
import { capitalizeString } from "../../../shared/util";
import { ContentHeader } from "../../components/ContentHeader/ContentHeader";
import ConnectionRequest from "../../components/Forms/Modal/ConnectionRequest/Connection-Request";
import RegisterModal from "../../components/Forms/Modal/Register";
import {
  Actor,
  AuthMessages,
  CommonEntity,
  Contact,
  PropsEntities,
  RecordStatus,
  RequestStatus,
  TokenType,
  User,
} from "../..";
import { authCode, getCode, registerUser } from "../../../controllers/auth";
import {
  IconType,
  NotificationPlacement,
} from "antd/es/notification/interface";
import { ActionsetUser } from "../../../controllers/store/actions/user/actions";
import store from "../../../controllers/store/";
import { useSelector } from "react-redux";
import { RequestConnection } from "../../../models/RequestConnection";
import { saveRequest, sendNotification } from "../../../controllers/connection";
import { getSended } from "../../../controllers/store/actions/connection/connection-sended-actions";

const { Paragraph } = Typography;
type NotificationType = "success" | "info" | "warning" | "error";

const dispatch = store.dispatch;
const Entities = ({ data }: PropsEntities) => {
  const user = useSelector((state: any) => {
    return state.user.user;
  });

  const [loading, setLoading] = useState(false);
  const [code, setcode] = useState<boolean>(false);
  const [email, setEmail] = useState<string>();
  const [modalLoading, setModalLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [toggleLogin, setToggleLogin] = useState(false);
  const [notify, setNotification] = useState(false);
  const [isModalRegisterOpen, setIsModalRegisterOpen] = useState(false);
  const navigate = useNavigate();
  const [entities, setEntities] = useState([]);
  const [contact, setContact] = useState<Contact>();
  const [universities, setUniversities] = useState([]);
  const [searcher, setSearchers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [initialData, setInitialData] = useState<CommonEntity[]>([]);
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (placement: NotificationPlacement) => {
    api.info({
      type: TokenType.success as IconType,
      message: AuthMessages.Title,
      description: AuthMessages.AccountCreated,
      placement,
    });
  };

  const openNotificationWithIcon = (type: NotificationType) => {
    api[type]({
      message: "UNAB",
      description: "Solicitud enviada correctamente.",
    });
  };

  useEffect(() => {
    document.title = "UNAB - Entidades";
    setEntities(data.entities || []);
    setUniversities(data.universities || []);
    setSearchers(data.searcher || []);
    setGroups(data.groups || []);
    setInitialData(data.initialDataEntities || []);
    setLoading(data.loading || false);

    if (notify) {
      openNotification("topRight");
    }
  }, [
    notify,
    data.entities,
    data.universities,
    data.searcher,
    data.groups,
    data.loading,
    data.initialDataEntities,
  ]);

  const { Text } = Typography;

  const detail = (params: any, entity: string) => {
    navigate(`${params.id}`, { state: { params, entity } });
  };

  const doAuth = async (data: any) => {
    try {
      if (data.username && !data.code) {
        setLoading(true);
        await getCode({
          username: data.username,
        });

        setcode(true);
      }

      if (data.username && data.code) {
        setLoading(true);
        const user = await authCode({
          username: data.username,
          code: data.code,
        });
      }

      setLoading(false);
    } catch (e) {
      message.error("Usuario no encontrado");
      setLoading(false);
    }
  };

  return (
    <div className="full-width">
      {contextHolder}
      <RegisterModal
        toggleLogin={toggleLogin}
        loading={modalLoading}
        visible={isModalRegisterOpen}
        showCodeField={code}
        email={email}
        onSuccessLogin={(user: User) => {
          dispatch(ActionsetUser(user));
          setIsModalRegisterOpen(false);
          setIsModalOpen(!isModalOpen);
        }}
        onCancel={() => setIsModalRegisterOpen(false)}
        onRegister={async (values: any) => {
          try {
            setModalLoading(true);
            const response = await registerUser({
              ...values,
            });

            try {
              await doAuth({
                username: values.email,
              });

              api["success"]({
                message: "UNAB",
                description:
                  "Cuenta creada correctamente. Revisa tu bandeja de entrada para acceder con el código.",
              });
              setEmail(values.username);
            } catch (error) {
              api["error"]({
                message: "UNAB",
                description: "Ocurrio un error intente mas tarde.",
              });
            }

            setToggleLogin(true);
          } catch (error) {
            setIsModalRegisterOpen(false);
          }

          setModalLoading(false);
        }}
      />
      <ConnectionRequest
        open={isModalOpen}
        onOk={(value: any, text: string) => {
          console.log("contact", contact);
          const request = new RequestConnection(
            "",
            text,
            user.me,
            {
              name: contact?.name || "",
              email: contact?.email || "",
              organization_name:
                contact?.organization_name || contact?.name || "",
              type: contact?.type || "",
              cityRaw: contact?.cityRaw || "",
              city: contact?.city || "",
            },
            RequestStatus.Pending,
            value.requestType || "",
            contact?.type
          );
          saveRequest(request);
          sendNotification(request);
          setIsModalOpen(false);
          openNotificationWithIcon("success");
          dispatch(
            getSended(
              "connection_request",
              {
                meta: "filter_count",
                filter: `&filter[user_created][id][_eq]=${user.me.id}&filter[status][_eq]=${RecordStatus.Active}`,
              },
              1,
              10
            )
          );
        }}
        onCancel={() => setIsModalOpen(false)}
        contact={{
          name: contact?.name || "",
          email: contact?.email || "",
          organization_name: contact?.organization_name || "",
          cityRaw: contact?.cityRaw,
          city: contact?.city || "",
          type: contact?.type.actor || "",
        }}
      />
      <div className="content-header">
        <ContentHeader title="Entidad" />
      </div>
      <Skeleton loading={loading} active className="full-width">
        {initialData.length > 0 &&
        entities.length === 0 &&
        universities.length === 0 &&
        searcher.length === 0 ? (
          <div className="full-width">
            <Row gutter={[8, 8]} style={{ width: "100%", textAlign: "center" }}>
              {initialData.map((item: CommonEntity) => (
                <Col key={item.id} xs={24} sm={12} md={8} lg={6}>
                  <Card
                    className="ant-card-conection"
                    hoverable
                    style={{ width: "100%", marginBottom: 30 }}
                  >
                    {item.recommended ? (
                      <Space
                        style={{ position: "absolute", top: 10, right: 10 }}
                      >
                        <Badge dot color="green">
                          <StarOutlined style={{ fontSize: 16 }} />
                        </Badge>
                        Sugerido
                      </Space>
                    ) : null}
                    <div
                      className="with-pointer"
                      onClick={() => {
                        console.log("item", item);
                        if (item.collection_name === Actor.Company) {
                          detail(item, Actor.Company);
                        }

                        if (item.collection_name === Actor.InnovativeCompany) {
                          detail(item, Actor.InnovativeCompany);
                        }

                        if (
                          item.collection_name === Actor.ProminentResearcher
                        ) {
                          navigate(`/searchers/${item.id}`, {
                            state: { params: item, entityType: "searchers" },
                          });
                        }

                        if (item.collection_name === Actor.University) {
                          navigate(`/universities/${item.id}`, {
                            state: { params: item, entityType: "universities" },
                          });
                        }

                        if (item.collection_name === Actor.Commons) {
                          navigate(`/commons-entities/${item.id}`, {
                            state: { params: item, entityType: Actor.Commons },
                          });
                        }

                        if (item.collection_name === Actor.ResearchGroup) {
                          navigate(`/groups/${item.id}`, {
                            state: {
                              params: item,
                              entityType: Actor.ResearchGroup,
                            },
                          });
                        }
                      }}
                    >
                      <h3 style={{ margin: 0 }}>
                        <Paragraph
                          style={{ marginBottom: "0px" }}
                          ellipsis={{
                            rows: 2,
                            expandable: true,
                            symbol: "Más",
                            tooltip: (item.name || "").toLowerCase(),
                          }}
                        >
                          {item.name.toLocaleUpperCase()}
                        </Paragraph>
                      </h3>
                      <br />
                      <Text type="secondary">{item.type?.actor}</Text>
                      <br />
                      <p style={{ marginTop: 5, marginBottom: 5 }}>
                        <EnvironmentOutlined color="#2a0089" />{" "}
                        {item.city || ""}
                      </p>
                      <br />
                    </div>
                    <Meta
                      title={""}
                      description={
                        <Button
                          className="ant-card-conection-btn"
                          onClick={() => {
                            console.log("item", item);

                            setContact({ ...item, email: item.contact_email });
                            if (user) {
                              setIsModalOpen(!isModalOpen);
                            } else {
                              setIsModalRegisterOpen(!isModalRegisterOpen);
                            }
                          }}
                          type="primary"
                          block
                        >
                          Conectar
                        </Button>
                      }
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        ) : null}
        {entities.length === 0 ? null : (
          <div className="full-width">
            <Row gutter={[8, 8]} style={{ width: "100%", textAlign: "center" }}>
              {entities.map((f: any) => {
                if (f.entities_id) {
                  return (
                    <Col key={f.id} xs={24} sm={12} md={8} lg={6}>
                      <Card
                        className="ant-card-conection"
                        onClick={() => {
                          detail(f.entities_id, "entities");
                        }}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <h3 style={{ margin: 0 }}>
                          {capitalizeString(f.entities_id.social_reason || "")}{" "}
                        </h3>
                        <br />
                        <Text type="secondary">
                          {capitalizeString(f.entities_id.actor_type?.actor)}
                        </Text>
                        <br />
                        <p>
                          <EnvironmentOutlined color="#2a0089" />{" "}
                          {f.entities_id.city || f.entities_id.cityRaw || ""}
                        </p>
                        <br />
                        <Meta
                          title={""}
                          description={
                            <Button
                              className="ant-card-conection-btn"
                              onClick={() => {
                                setIsModalOpen(true);
                              }}
                              type="primary"
                              block
                            >
                              Conectar
                            </Button>
                          }
                        />
                      </Card>
                    </Col>
                  );
                }

                return (
                  <Col key={f.id} xs={24} sm={12} md={8} lg={6}>
                    <Card
                      className="ant-card-conection"
                      onClick={() => detail(f, "entities")}
                      hoverable
                      style={{ width: "100%", marginBottom: 30 }}
                    >
                      <h3 style={{ margin: 0 }}>
                        {capitalizeString(f.social_reason || "")}
                      </h3>
                      <br />
                      <Text type="secondary">
                        {capitalizeString(f.actor_type?.actor)}
                      </Text>
                      <br />
                      <p>
                        <EnvironmentOutlined color="#2a0089" />{" "}
                        {f.city || f.cityRaw || ""}
                      </p>
                      <br />
                      <Meta
                        title={""}
                        description={
                          <Button
                            className="ant-card-conection-btn"
                            onClick={() => {
                              setIsModalOpen(true);
                            }}
                            type="primary"
                            block
                          >
                            Conectar
                          </Button>
                        }
                      />
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}
        {universities.length === 0 ? null : (
          <div>
            <Row gutter={[8, 8]} style={{ width: "100%", textAlign: "center" }}>
              {universities.map((f: any) => (
                <Col key={f.id} xs={24} sm={12} md={8} lg={6}>
                  <Card
                    onClick={() => detail(f, "universities")}
                    hoverable
                    style={{ width: "100%" }}
                  >
                    <h3 style={{ margin: 0 }}>
                      {capitalizeString(f.institution_name || "")}
                    </h3>
                    <Text type="secondary">
                      {capitalizeString(f.actor_type.actor)}
                    </Text>
                    <br />
                    <p>
                      <EnvironmentOutlined color="#2a0089" />{" "}
                      {capitalizeString(f.municipality || "")}
                    </p>

                    <Meta
                      title={f.url || ""}
                      description={
                        <Button
                          style={{ fontWeight: "bolder" }}
                          onClick={() => {
                            setIsModalOpen(true);
                          }}
                          disabled={f.features !== "test" ? false : true}
                          type="primary"
                          block
                        >
                          Conectar
                        </Button>
                      }
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        )}
        {searcher.length === 0 ? null : (
          <div>
            <Row gutter={[8, 8]} style={{ width: "100%", textAlign: "center" }}>
              {searcher.map((f: any) => (
                <Col key={f.id} xs={24} sm={12} md={8} lg={6}>
                  <Card
                    onClick={() => {
                      navigate(`/searchers/${f.id}`, {
                        state: { searcherParam: f, entityType: "searchers" },
                      });
                    }}
                    hoverable
                    style={{ width: "100%" }}
                  >
                    <h3 style={{ margin: 0 }}>
                      {capitalizeString(f.nombre || "")}
                    </h3>
                    <Text type="secondary">
                      Nivel - {capitalizeString(f.nme_niv_form_pr)}
                    </Text>
                    <br />
                    <Text>{f.nombre}</Text>
                    <p>
                      <EnvironmentOutlined color="#2a0089" />{" "}
                      {capitalizeString(f.nme_municipio_res_pr || "")}
                    </p>

                    <Meta
                      title={
                        <a href={f.enlace_cvlac} target="_blank">
                          {f.enlace_cvlac}
                        </a>
                      }
                      description={
                        <Button
                          style={{ fontWeight: "bolder" }}
                          onClick={() => {
                            setIsModalOpen(true);
                          }}
                          disabled={f.features !== "test" ? false : true}
                          type="primary"
                          block
                        >
                          Conectar
                        </Button>
                      }
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        )}
        {groups.length === 0 ? null : (
          <Row gutter={[8, 8]} style={{ width: "100%", textAlign: "center" }}>
            {groups.map((f: any) => (
              <Col key={f.id} xs={24} sm={12} md={8} lg={6}>
                <Card
                  onClick={() => {
                    navigate(`/groups/${f.id}`, {
                      state: { group: f, entityType: "groups" },
                    });
                  }}
                  hoverable
                  style={{ width: "100%" }}
                >
                  <h3 style={{ margin: 0 }}>
                    {capitalizeString(f.NME_GRUPO_GR || "")}
                  </h3>
                  <Text type="secondary">
                    {capitalizeString(f.ACTOR_TYPE?.actor || "")}
                  </Text>
                  <br />
                  <Text>{f.nombre || ""}</Text>
                  <p>
                    <EnvironmentOutlined color="#2a0089" />{" "}
                    {capitalizeString(f.NME_MUNICIPIO_GR || "")}
                  </p>

                  <Meta
                    title={
                      <a href={f.enlace_cvlac} target="blank">
                        {f.enlace_cvlac}
                      </a>
                    }
                    description={
                      <Button
                        style={{ fontWeight: "bolder" }}
                        onClick={() => {
                          setIsModalOpen(true);
                        }}
                        disabled={f.features !== "test" ? false : true}
                        type="primary"
                        block
                      >
                        Conectar
                      </Button>
                    }
                  />
                </Card>
              </Col>
            ))}
          </Row>
        )}
        {initialData.length === 0 &&
        groups.length === 0 &&
        entities.length === 0 &&
        universities.length === 0 &&
        searcher.length === 0 ? (
          <Row gutter={[8, 8]} className="full-width">
            <Col xs={24} sm={12} md={8} lg={24}>
              {initialData.length === 0 ? (
                <Empty description={"Sin Resultados"} />
              ) : null}
            </Col>
          </Row>
        ) : null}
      </Skeleton>
    </div>
  );
};

export default Entities;
